// extracted by mini-css-extract-plugin
export var dateLabel = "_2p-0";
export var dateLabelError = "_2p-1";
export var fullWidth = "_2p-2";
export var smaller = "_2p-3";